import React, { useState } from "react";
import patchNotesData from "./data/patchNotesData";
import "./ReleaseNotes.scss";

import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import { Notebook } from "lucide-react";

const ReleaseNotes = () => {
  const [selectedVersion, setSelectedVersion] = useState(
    patchNotesData[0].version
  );

  const currentNote = patchNotesData.find(
    (note) => note.version === selectedVersion
  );

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar title="Notas de Atualizações" icon={Notebook} />
        <div className="patch-notes-container">
          <div className="patch-nav">
            <label htmlFor="version-select">Versão:</label>
            <select
              id="version-select"
              value={selectedVersion}
              onChange={(e) => setSelectedVersion(e.target.value)}
            >
              {patchNotesData.map((note) => (
                <option key={note.version} value={note.version}>
                  {note.version} ({note.date})
                </option>
              ))}
            </select>
          </div>

          {currentNote && (
            <div className="patch-version-block">
              <h2 className="patch-version-title">
                Versão {currentNote.version}
                <span className="patch-version-date">({currentNote.date})</span>
              </h2>
              <ul className="patch-changes-list">
                {currentNote.changes.map((change, idx) => (
                  <li key={idx} className="patch-change-item">
                    {change.title && (
                      <p className="patch-changes-title">{change.title}</p>
                    )}
                    <p className="patch-changes-text">{change.text}</p>
                    {change.images && (
                      <div className="patch-image-gallery">
                        {change.images.map((img, i) => (
                          <img
                            key={i}
                            src={img.path}
                            style={{ width: img.width, height: img.height }}
                            alt={`Nota ${idx + 1} - Imagem ${i + 1}`}
                            className="patch-image"
                          />
                        ))}
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
